import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-footer',
  templateUrl: './cyclops-footer.component.html',
  styleUrls: ['./cyclops-footer.component.scss']
})
export class cyclopsFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
